import * as React from "react";
import { forwardRef } from "react";
const SvgDownload = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 12.303, height: 16.404, viewBox: "0 0 12.303 16.404", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M5.468 0v11.32l-3.61-3.61-.983.983 4.784 4.784.491.47.491-.47 4.784-4.784-.983-.983-3.61 3.61V0ZM0 15.037V16.4h12.3v-1.363Z", className: "s11c3e19f8fdccc98fc2d86541674a3b3__a" }));
const ForwardRef = forwardRef(SvgDownload);
export { ForwardRef as ReactComponent };
